import BaseApi from '@/api/baseApi';

export default class UserAvatarApi extends BaseApi {
  constructor(obj) {
    obj = obj || {};
    super(obj);
  }

  async upload(userId, formData) {
    const response = await this.api({
      method: 'post',
      url: `/users/${userId}/avatar`,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response;
  }

  async getAvatarBlob(userId) {
    const response = await this.api.get(`/users/${userId}/avatar`, {
      responseType: 'blob',
      validateStatus: (status) => status === 200 || status === 204,
    });

    if (response.status === 204) {
      return null;
    }

    return response;
  }

  async remove(userId) {
    const response = await this.api.delete(`/users/${userId}/avatar`);

    return response;
  }
}
